import React, { useEffect, useState } from "react";
import { Box, Checkbox, Divider, FormControlLabel, FormHelperText, Grid, Typography } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Form, FormikErrors, FormikTouched } from "formik";
import dayjs from 'dayjs';
import { MakeBeacon } from "../../../../types/models/MakeBeacon";
import { addDays } from "../../../../utils/utils";
import { AppColor } from "../../../../types/Constants";
import { BeaconDialogModes } from "./BeaconDialog";
import { formatDistanceStrict, formatDuration, intervalToDuration } from "date-fns";

interface BeaconScheduleFormProps {
  values: MakeBeacon,
  errors: FormikErrors<MakeBeacon>,
  touched: FormikTouched<MakeBeacon>,
  handleChange: (e: React.ChangeEvent<any>) => void,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => Promise<void | FormikErrors<MakeBeacon>>
  mode?: typeof BeaconDialogModes[number]
}

const BeaconScheduleForm: React.FC<BeaconScheduleFormProps> = ({ values, errors, touched, handleChange, setFieldValue, mode }) => {

  const [startDate, setStartDate] = useState<dayjs.Dayjs>(dayjs(new Date()));
  const [endDate, setEndDate] = useState<dayjs.Dayjs>(dayjs(new Date()));
  const [diffHours, setDiffHours] = useState<number>();
  const [isAlwaysActive, setIsAlwaysActive] = useState<boolean>(values.startDate == "" && values.endDate == "");

  useEffect(() => {
    if (values.startDate && !isAlwaysActive) {
      setStartDate(dayjs(new Date(values.startDate)));
    }
    else {
      setFieldValue("startDate", "");
    }

    if (values.endDate && !isAlwaysActive) {
      setEndDate(dayjs(new Date(values.endDate)));
    }
    else {
      setFieldValue("endDate", "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const end = new Date(values.endDate);
  //   const start = new Date(values.startDate);

  //   var diff = end.valueOf() - start.valueOf();
  //   var diffInHours = diff / 1000 / 60 / 60;

  //   if (diffInHours < 0) {
  //     diffInHours = 0;
  //   }

  //   // Round up the diff hours
  //   setDiffHours(Math.ceil(diffInHours));

  // }, [values.startDate, values.endDate]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsAlwaysActive(checked);

    if (checked) {
      setFieldValue("startDate", "");
      setFieldValue("endDate", "");
    } else {
      setFieldValue("startDate", new Date());
      setFieldValue("endDate", addDays(new Date(), 1));
    }
    handleChange(event);
  };

  return (
    <Form style={{ width: "100%", marginTop: 8 }}>
      <Box sx={{ p: 2 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* Grid for DT Pick Controls */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Box sx={{ width: "25%" }}>
              <DateTimePicker
                disabled={isAlwaysActive || mode === "MOD_ONLY" || mode === "READ_ONLY"}
                sx={{ width: "100%" }}
                label="Start time"
                value={startDate}
                onChange={(value) => setFieldValue("startDate", value)}
              />
              <FormHelperText
                error={
                  (errors.startDate ? true : undefined) && touched.startDate
                }
              >
                {errors.startDate && touched.startDate
                  ? errors.startDate
                  : null}
              </FormHelperText>
            </Box>
            <Box sx={{ width: "25%"}}>
              <DateTimePicker
                disabled={isAlwaysActive || mode === "MOD_ONLY" || mode === "READ_ONLY"}
                sx={{ width: "100%" }}
                label="End time"
                value={endDate}
                onChange={(value) => setFieldValue("endDate", value)}
              />
              <FormHelperText
                error={(errors.endDate ? true : undefined) && touched.endDate}
              >
                {errors.endDate && touched.endDate ? errors.endDate : null}
              </FormHelperText>
            </Box>
            <Box sx={{ display: "flex", alignContent: "center", ml: 6 }}>
              <FormControlLabel control={<Checkbox checked={isAlwaysActive} onChange={handleCheckboxChange}/>} label="Always Active" />
            </Box>
          </Box>
        </LocalizationProvider>
        {/* <Divider light sx={{ my: 4 }} /> */}

        {/* Grid for summary labels */}
        {/* <Grid container justifyContent="space-between">
          <Grid item xs={6}>
            <Typography variant="caption">Duration</Typography>
            <Typography variant="h5">
              {values.endDate > values.startDate
                ? formatDuration(
                    intervalToDuration({
                      start: new Date(values.startDate),
                      end: new Date(values.endDate),
                    }),
                    {
                      format: ["years", "months", "weeks", "days", "hours"],
                      delimiter: ", ",
                    }
                  )
                : "Invalid Date Range"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography display="block" variant="caption" align="right">
              Cost (USD)
            </Typography>
            <Typography variant="h5" align="right">
              {`$${diffHours?.toLocaleString() ?? 0}`}
            </Typography>
          </Grid>
        </Grid>
        <Box
          sx={{
            border: "1px solid silver",
            borderRadius: 2,
            px: 3,
            py: 1,
            width: "50%"
          }}>
          <Typography sx={{ color: AppColor.subHeaderText }}>Duration (Hour)</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Typography>{diffHours?.toLocaleString() ?? 0}</Typography>
            <Typography>Hours</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            border: "1px solid silver",
            borderRadius: 2,
            px: 3,
            py: 1,
            width: "50%",
            mt: 4
          }}>
          <Typography sx={{ color: AppColor.subHeaderText }}>Cost (USD)</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Typography>$ {diffHours?.toLocaleString() ?? 0}</Typography>
            <Typography>USD</Typography>
          </Box>
        </Box> */}
      </Box>
    </Form>
  );
};

export default BeaconScheduleForm;
